import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ModalActionsComponent } from '@app/components';
import { useTypedTranslation } from '@app/hooks';
import { getModalSwitch} from '@app/store/actions';
import { IOrganizationDetail } from '@app/models';
import { organizationsService, basicService } from '@app/services';
import { genericErrorToast, defaultOrgId } from '@app/helpers';

export const DeleteOrganizationDialog = () => {
    const dispatch = useDispatch();
    const { translation } = useTypedTranslation();

    const thisOrganization: IOrganizationDetail = useSelector((state: any) => state.orgs.organization);
    const organizationFilter = useSelector((state: any) => state.organizationSelect.selectedOrganization);

    const handleCancel = () => {
        dispatch(getModalSwitch(false));
    };

    const handleDeleteOrganization = () => {
        organizationsService.deleteOrgs(thisOrganization.Id, genericErrorToast, handleDeleteOrgSuccess);
    };

    const handleDeleteOrgSuccess = () => {
        if (thisOrganization.Id === organizationFilter) {
            // If we're deleting the child org we're currently filtered to
            // then reset the filter to the default org
            basicService.setOrgFilter(defaultOrgId);
        }

        // too much changes with the site on org delete, do a browser navigation
        window.location.href = window.location.origin + '/directory/orgs/';
    };

    return (
        <>
            <div className='modal__body--row'>{translation('DELETE_ORG_BODY')}</div>
            <ModalActionsComponent
                primaryBtn={translation('DELETE')}
                secondaryBtn={translation('CANCEL')}
                onClickPrimary={handleDeleteOrganization}
                onClickSecondary={handleCancel}
                disabled={false}
                id='deleteOrg'
                isDeleteAction={true}
            />
        </>
    );
};